export const DEFAULT_BANK_ICON_ID = "bank-default";

export const BANK_ICON_OPTIONS = [
  {
    id: DEFAULT_BANK_ICON_ID,
    label: "Banco",
    aliases: [],
    bg: "#334155",
    fg: "#ffffff",
    text: "",
  },
  {
    id: "nubank",
    label: "Nubank",
    aliases: ["nu", "nubank", "roxinho"],
    bg: "#820ad1",
    fg: "#ffffff",
    text: "nu",
  },
  {
    id: "itau",
    label: "Itau",
    aliases: ["itau", "itaú"],
    bg: "#ff7900",
    fg: "#ffffff",
    text: "itau",
  },
  {
    id: "bradesco",
    label: "Bradesco",
    aliases: ["bradesco"],
    bg: "#cc092f",
    fg: "#ffffff",
    text: "b",
  },
  {
    id: "santander",
    label: "Santander",
    aliases: ["santander"],
    bg: "#e60000",
    fg: "#ffffff",
    text: "S",
  },
  {
    id: "bb",
    label: "Banco do Brasil",
    aliases: ["bb", "banco do brasil", "bancodobrasil"],
    bg: "#f8df00",
    fg: "#1e3a8a",
    text: "BB",
  },
  {
    id: "caixa",
    label: "Caixa",
    aliases: ["caixa", "cef", "caixa economica"],
    bg: "#005ca9",
    fg: "#ffffff",
    text: "X",
  },
  {
    id: "inter",
    label: "Inter",
    aliases: ["inter", "banco inter"],
    bg: "#ff7a00",
    fg: "#ffffff",
    text: "inter",
  },
  {
    id: "c6",
    label: "C6 Bank",
    aliases: ["c6", "c6 bank", "c6bank"],
    bg: "#111827",
    fg: "#fbbf24",
    text: "C6",
  },
  {
    id: "btg",
    label: "BTG Pactual",
    aliases: ["btg", "btg pactual", "pactual"],
    bg: "#0f3f8a",
    fg: "#ffffff",
    text: "btg",
  },
  {
    id: "bmg",
    label: "BMG",
    aliases: ["bmg"],
    bg: "#f59e0b",
    fg: "#ffffff",
    text: "BMG",
  },
  {
    id: "mercado-pago",
    label: "Mercado Pago",
    aliases: ["mercado pago", "mercadopago", "mp"],
    bg: "#00aeef",
    fg: "#ffffff",
    text: "MP",
  },
  {
    id: "xp",
    label: "XP",
    aliases: ["xp", "xp investimentos"],
    bg: "#111827",
    fg: "#f9fafb",
    text: "XP",
  },
  {
    id: "picpay",
    label: "PicPay",
    aliases: ["picpay", "pic pay"],
    bg: "#11c76f",
    fg: "#ffffff",
    text: "P",
  },
  {
    id: "paypal",
    label: "PayPal",
    aliases: ["paypal", "pay pal"],
    bg: "#003087",
    fg: "#ffffff",
    text: "P",
  },
  {
    id: "wise",
    label: "Wise",
    aliases: ["wise", "transferwise"],
    bg: "#9fe870",
    fg: "#163300",
    text: "W",
  },
  {
    id: "sicredi",
    label: "Sicredi",
    aliases: ["sicredi"],
    bg: "#3fa535",
    fg: "#ffffff",
    text: "S",
  },
  {
    id: "sicoob",
    label: "Sicoob",
    aliases: ["sicoob"],
    bg: "#005247",
    fg: "#ffffff",
    text: "S",
  },
  {
    id: "banrisul",
    label: "Banrisul",
    aliases: ["banrisul"],
    bg: "#005daa",
    fg: "#ffffff",
    text: "B",
  },
  {
    id: "pan",
    label: "Banco Pan",
    aliases: ["pan", "banco pan", "bancopan"],
    bg: "#00a3e0",
    fg: "#ffffff",
    text: "PAN",
  },
  {
    id: "original",
    label: "Original",
    aliases: ["original", "banco original"],
    bg: "#00a443",
    fg: "#ffffff",
    text: "O",
  },
  {
    id: "next",
    label: "Next",
    aliases: ["next"],
    bg: "#00e676",
    fg: "#0f172a",
    text: "next",
  },
  {
    id: "pagbank",
    label: "PagBank",
    aliases: ["pagbank", "pagseguro", "pag seguro"],
    bg: "#facc15",
    fg: "#111827",
    text: "pag",
  },
  {
    id: "neon",
    label: "Neon",
    aliases: ["neon", "banco neon"],
    bg: "#00a6ff",
    fg: "#ffffff",
    text: "n",
  },
  {
    id: "stone",
    label: "Stone",
    aliases: ["stone"],
    bg: "#00a868",
    fg: "#ffffff",
    text: "S",
  },
];

export function normalizeBankName(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function getBankIcon(iconId) {
  return BANK_ICON_OPTIONS.find((icon) => icon.id === iconId) || null;
}

export function findBankIconByName(value) {
  const normalized = normalizeBankName(value);
  if (!normalized) return null;

  return (
    BANK_ICON_OPTIONS.find((icon) => {
      if (icon.id === DEFAULT_BANK_ICON_ID) return false;
      const keys = [icon.id, icon.label, ...icon.aliases].map(normalizeBankName);
      return keys.some((key) => key && (normalized === key || normalized.includes(key)));
    }) || null
  );
}

export function resolveBankIcon(iconId, bankName) {
  return getBankIcon(iconId) || findBankIconByName(bankName) || getBankIcon(DEFAULT_BANK_ICON_ID);
}
